import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IFederalLaw } from '../interfaces/IFederalLaw';

export async function fetchFederalLaws(isErknm: boolean): Promise<IFederalLaw[]> {
  return apiGet<IFederalLaw[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/federal-laws?enabledERP=${!isErknm}`,
  );
}

export async function fetchFederalLawsByKno(kno: string): Promise<string[]> {
  return apiGet<string[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/dictionaries/federal-laws-by-kno/${kno}`);
}

export async function fetchFederalLawsByKnoDirect(kno: string): Promise<string[]> {
  return apiGet<string[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/dictionaries/federal-laws-by-kno-direct/${kno}`,
  );
}
